import {
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type {
    TimeInputCombinedProps,
    TimeInputHelperProps
} from "./type";
import stylesheet, {
    TIME_INPUT_DIGIT_COUNT,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import NumericInput from "../../../numericInput";

const TimeInput: FC<TimeInputCombinedProps> = ({
    isInvalid = false,
    customTheme,
    helperText,
    helperID,
    ...props
}) => {
    const {
        controlPaddings,
        controlHeights,
        borders
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlPaddings,
        controlHeights,
        borders
    });

    const getHelperProps = (): TimeInputHelperProps => {
        if(!isInvalid || !helperText) {
            return {};
        }

        if(Platform.OS === "web") {
            return {
                "aria-describedby": helperID
            };
        }

        return {
            accessibilityHint: helperText
        };
    };

    return <NumericInput
        {...props}
        {...getHelperProps()}
        type={isInvalid ? "danger" : "neutral"}
        maxLength={TIME_INPUT_DIGIT_COUNT}
        inputStyle={stylesheet.input}
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        isMinWidthEnabled={false}
        customTheme={customTheme}
        selectTextOnFocus={true}
        spreadBehaviour="free"
        size="medium"
    />;
};
export default TimeInput;
